<script setup>
import { WAutocomplete } from '@alice-health/wonderland-vue'
import debounce from 'lodash/debounce'
import { reactive } from 'vue'

const props = defineProps({
  id: {
    type: String,
    default: 'autocomplete-search'
  },
  value: {
    type: [Object, String, Array],
    default: undefined
  },
  label: {
    type: String,
    default: undefined
  },
  valueKey: {
    type: String,
    default: 'name'
  },
  required: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  },
  placeholder: {
    type: String,
    default: ''
  },
  searchFunction: {
    type: Function,
    default: () => []
  },
  icon: {
    type: String,
    default: 'icSearch'
  }
})
const emit = defineEmits(['input'])

const state = reactive({
  loading: false,
  results: [],
  abortController: null,
  query: null
})

const handleSelect = value => {
  emit('input', value)
}

const handleChange = debounce(async function (query) {
  let results = []
  state.query = query
  if (!query || query.length <= 2) return

  state.abortController?.abort()
  state.abortController = new AbortController()
  state.loading = true
  results = await props.searchFunction(query, state.abortController.signal)
  state.loading = false
  state.results = results || []
}, 200)
</script>

<template>
  <WAutocomplete
    :id="id"
    :name="id"
    :label="label"
    :required="required"
    :loading="state.loading"
    :leading-icon="icon"
    :placeholder="props.placeholder"
    :search-by-key="props.valueKey"
    :items="state.results"
    :value="value"
    @w-select="handleSelect($event.detail)"
    @w-change="handleChange($event.detail)"
  />
</template>
